import * as React from 'react'; // eslint-disable-line
import styled from 'styled-components';

import { COLOR, FONT_SIZE, SPACING, SPACING_SCALE, SPEED } from '../../packages/constants';

export interface BreadcrumbsProps {
    children: React.ReactNode;
}

interface BreadcrumbsLinkProps {
    children: React.ReactNode;
    dataId: string;
    href: string;
    target?: '_blank' | '_self' | '_parent' | '_top';
    theme?: any;
}

const StyledBreadcrumbs = styled.div`
    margin-bottom: ${SPACING_SCALE * 8}px;
    padding-top: ${SPACING_SCALE * 3}px;
`;

const StyledBreadcrumbsList = styled.ol`
    display: flex;
    flex-wrap: wrap;
`;

const StyledBreadcrumbsListItem = styled.li`
    display: flex;
    margin-right: ${SPACING.MEDIUM};
    padding-right: ${SPACING.SMALL};
    position: relative;
    font-size: ${FONT_SIZE.SMALL};
    color: ${COLOR.MAIN.DARK_GREY};

    &::before,
    &::after {
        left: 100%;
        top: 50%;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    &::after {
        border-color: transparent;
        border-left-color: ${COLOR.PRIMARY.WHITE};
        border-width: 5px;
        margin-top: -5px;
    }

    &::before {
        border-color: transparent;
        border-left-color: ${COLOR.MAIN.FORM_FIELD_DARK};
        border-width: 6px;
        margin-top: -6px;
    }

    &:last-child {
        &::before,
        &::after {
            display: none;
        }
    }
`;

const StyledBreadcrumbsLink = styled.a.attrs<BreadcrumbsLinkProps>(({ dataId }) => ({
    'data-test-id': dataId,
}))`
    transition: border-bottom-color ${SPEED.TRANSITION};
    color: ${(props) => (props.theme ? props.theme.main : COLOR.BRAND.REPORTING) || COLOR.BRAND.REPORTING};
    text-decoration: none;
    padding-bottom: 1px;
    border-bottom: 1px solid transparent;

    &:hover {
        border-bottom: 1px solid ${(props) => (props.theme ? props.theme.main : COLOR.BRAND.REPORTING)};
    }
`;

export const Breadcrumbs = ({ children, ...props }: BreadcrumbsProps) => (
    <StyledBreadcrumbs {...props}>
        <StyledBreadcrumbsList>
            {
                //
                // @ts-ignore
                children.length && children.map ? (
                    // @ts-ignore
                    children.map(
                        (child: any, i: number) =>
                            child &&
                            (child.length || child.props) && (
                                <StyledBreadcrumbsListItem key={child.key || i}>{child}</StyledBreadcrumbsListItem>
                            ),
                    )
                ) : (
                    <StyledBreadcrumbsListItem>{children}</StyledBreadcrumbsListItem>
                )
            }
        </StyledBreadcrumbsList>
    </StyledBreadcrumbs>
);

export const BreadcrumbsLink = ({ children, ...props }: BreadcrumbsLinkProps) => (
    <StyledBreadcrumbsLink {...props}>{children}</StyledBreadcrumbsLink>
);
